import { useMemo } from 'react';

import * as ActionItem from '@/modules/tasks/features/actionItems/components/ActionItem';
import { ActionItemFragment } from '@/modules/tasks/features/actionItems/graphql/fragments/generated/ActionItem';

import useTaskListActionMenu from '../../../hooks/useTaskListActionMenu';

const LocalActionItemOptions = ({
  getActionMenu,
  rowData,
}: {
  getActionMenu: ReturnType<typeof useTaskListActionMenu>['getActionMenu'];
  rowData: ActionItemFragment;
}) => {
  const actionMenu = useMemo(() => getActionMenu(rowData), [getActionMenu, rowData]);

  return <ActionItem.Options actionMenu={actionMenu} />;
};

export default LocalActionItemOptions;
